import { GET_SETTINGS, SET_APP_MODE } from "./actionTypes";
import { GET_SETTINGS_URL, GET_SUPPORT_INFO_URL } from "../../configs";
import Axios from "axios";
import { AppMode } from "../../constants";

export const getSettings = () => (dispatch) => {
  Axios.post(GET_SETTINGS_URL)
    .then((response) => {
      const settings = response.data;
      
      // Store settings in localStorage
      if (settings && typeof settings === 'object') {
        Object.keys(settings).forEach(key => {
          if (settings[key] !== null && settings[key] !== undefined) {
            localStorage.setItem(key, settings[key]);
          }
        });
      }
      
      return dispatch({ type: GET_SETTINGS, payload: settings });
    })
    .catch(function(error) {
    });
};

export const getSupportInfo = (audience = "customer") => () =>
  Axios.post(GET_SUPPORT_INFO_URL, { audience }).then((response) => {
    const data = response.data?.data;
    if (data && audience === "customer") {
      if (data.intro) localStorage.setItem("customerSupportIntro", data.intro);
      if (data.email) localStorage.setItem("customerSupportEmail", data.email);
      if (data.phone) localStorage.setItem("customerSupportPhone", data.phone);
      if (data.address) localStorage.setItem("customerSupportAddress", data.address);
      if (data.whatsapp) localStorage.setItem("whatsAppNumber", data.whatsapp);
    }
    if (data && audience === "delivery") {
      if (data.intro) localStorage.setItem("deliverySupportIntro", data.intro);
      if (data.email) localStorage.setItem("deliverySupportEmail", data.email);
      if (data.phone) localStorage.setItem("deliverySupportPhone", data.phone);
      if (data.address) localStorage.setItem("deliverySupportAddress", data.address);
      if (data.whatsapp) localStorage.setItem("whatsAppNumber", data.whatsapp);
    }
    return response.data;
  });

export const setAppMode = (mode) => (dispatch) => {
  // Save to localStorage for persistence across page reloads
  localStorage.setItem('appMode', mode.toString());
  
  return dispatch({ type: SET_APP_MODE, payload: mode });
}

export const initializeAppMode = () => (dispatch) => {
  const savedMode = localStorage.getItem('appMode');
  if (savedMode) {
    // Relax is "coming soon": a previously saved Relax mode falls back to Rush.
    const parsed = parseInt(savedMode, 10);
    const mode = parsed === AppMode.RELAY ? AppMode.SPRINT : parsed;
    return dispatch({ type: SET_APP_MODE, payload: mode });
  }
  return Promise.resolve();
}
